// react
import React from 'react';
// components
import { Upload, Modal,message } from 'antd';
// utils
import { getBase64, getEnv, getValue } from '../utils';
// assets
import '../assets/css/uploadFile.less';
import {PlusOutlined } from '@ant-design/icons';

export default class UploadFile extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            previewVisible: false,
            previewImage: '',
            fileList: this.props.fileList || [],
            uploadData: {
                file_type: 'file',
                item_name: 'ssm'
            }
        };
    }

    handleCancel = () => this.setState({ previewVisible: false });

    handlePreview = async file => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }

        this.setState({
            previewImage: file.url || file.preview,
            previewVisible: true,
        });
    };
    checkFile = async (file)  => {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 2 ;
        if (!isJPG) {
            message.error('上传文件格式必须为jpg或png!');
            return  false ;
        }
        if (!isLt2M) {
            //图片大于2M 压缩处理
            const _this =this;
            return await new Promise((resolve) => {
                _this.photoCompress(file,{width:1024},(base64) => {
                    resolve(_this.convertBase64UrlToFile(base64,file.name));
                });
            });
             
        }
        return file;
        
    };
    photoCompress = (file,w,cb) => {
        const ready=new FileReader();
        /*开始读取指定的Blob对象或File对象中的内容. 当读取操作完成时,readyState属性的值会成为DONE,如果设置了onloadend事件处理程序,则调用之.同时,result属性中将包含一个data: URL格式的字符串以表示所读取文件的内容.*/
        ready.readAsDataURL(file);
        const _this = this;
        ready.onload=function(){
            const re=this.result;
            _this.canvasDataURL(re,w,cb);
        };
    };
    canvasDataURL = (path, obj, callback) => {
        const img = new Image();
        img.src = path;
        img.onload = function(){
            const that = this;
            // 默认按比例压缩
            let w = that.width,h = that.height,scale = w / h;
            w = obj.width || w;
            h = obj.height || (w / scale);
            let quality = 0.7;  // 默认图片质量为0.7
            //生成canvas
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            // 创建属性节点
            const anw = document.createAttribute('width');
            anw.nodeValue = w;
            const anh = document.createAttribute('height');
            anh.nodeValue = h;
            canvas.setAttributeNode(anw);
            canvas.setAttributeNode(anh);
            ctx.drawImage(that, 0, 0, w, h);
            // 图像质量
            if (obj.quality && obj.quality <= 1 && obj.quality > 0){
                quality = obj.quality;
            }
            // quality值越小，所绘制出的图像越模糊
            let base64 = canvas.toDataURL('image/jpeg', quality);
            // 回调函数返回base64的值
            callback(base64);
        };
    }
    convertBase64UrlToFile = (urlData,filename) => {
        let arr = urlData.split(','), mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type:mime});
    }
    handleChange = ({ file,fileList }) => {
        this.setState({fileList });
        // if (file.status === 'done'){
        //     let fileUrlList = fileList.map((item) => {return getValue(() => item.response.result);});
        //     let fileUrlListStr = fileUrlList.join(',');
        //     this.props.parentFileUrlListStr(fileUrlListStr);
        //     this.props.parentFileList(fileList);
        // }
        if (file.status === 'done' || file.status === 'removed'){
            let fileUrlList = fileList.map((item) => {
                if (item.url){
                    return `uploadfiles${item.url.split('uploadfiles')[1]}`;
                } else {
                    return getValue(() => item.response.result);
                }
            });
            let fileUrlListStr = fileUrlList.join(',');
            this.props.parentFileUrlListStr(fileUrlListStr);
            this.props.parentFileList(fileList);
        }
    };

    handleBeforeUpload = (file) => {
        return new Promise(async (resolve,reject) => {
            let resFile = await this.checkFile(file);
            if (!resFile) {
                reject(false);
            } else {
                resFile.uid = file.uid;
            }
            this.setState({
                uploadData: Object.assign({file_name: file.name}, this.state.uploadData)
            });
            
            resolve(resFile);
        });
        
        
    };

    render() {
        const { previewVisible, previewImage, fileList, uploadData } = this.state;
        const uploadButton = (
            <div>
                <PlusOutlined style={{fontSize: 26}} />
                <div className="ant-upload-text">上传图片</div>
            </div>
        );
        return (
            <div 
                className="clearfix" 
                style={{textAlign:'left'}}
            >
                <Upload
                    action={`https://${getEnv()}apigateway.gaodun.com/base/v1/upload/upload`}
                    beforeUpload={this.handleBeforeUpload}
                    data={uploadData}
                    fileList={fileList}
                    headers={{Accept: 'application/json'}}
                    listType="picture-card"
                    onChange={this.handleChange}
                    onPreview={this.handlePreview}
                    
                >
                    {fileList.length >= 4 ? null : uploadButton}
                </Upload>
                <div className="upload-tips">支持jpg. png. 格式，最多可上传4张</div>
                <Modal
                    footer={null}
                    onCancel={this.handleCancel}
                    visible={previewVisible}
                >
                    <img
                        src={previewImage}
                        style={{ width: '100%', padding: '20px' }} />
                </Modal>
            </div>
        );
    }
}